export var NativeStreamKeyIndexScope;
(function (NativeStreamKeyIndexScope) {
    NativeStreamKeyIndexScope["NATIVE_STREAM_KEY_INDEX_SCOPE_UNSPECIFIED"] = "NATIVE_STREAM_KEY_INDEX_SCOPE_UNSPECIFIED";
    NativeStreamKeyIndexScope["NATIVE_STREAM_KEY_INDEX_SCOPE_GLOBAL"] = "GLOBAL";
    NativeStreamKeyIndexScope["NATIVE_STREAM_KEY_INDEX_SCOPE_PARTITION_LOCAL"] = "PARTITION_LOCAL";
})(NativeStreamKeyIndexScope || (NativeStreamKeyIndexScope = {}));
